<template>
  <div
    class="bg-no-repeat bg-cover h-full"
    :style="
      'background-image: url(' +
      require('@/assets/images/home/首页背景.png') +
      ');'
    "
  >
    <div class="h-full flex flex-col">
      <div class="mb-60"></div>
      <div>
        <div
          class="mx-auto mb-2 max-w-sm w-4/5 bg-white border-t-4 border-blue-400 rounded shadow-lg hover:bg-gray-100"
          v-for="(item, index) in items"
          :key="index"
          @click="$router.push(item.link)"
        >
          <div class="flex items-center">
            <div class="flex-no-grow px-4 my-4 border-r border-gray-500">
              <img class="w-5" :src="`${item.icon}`" />
            </div>
            <div class="flex-grow px-4 my-4  text-lg">
              {{ item.title }}
            </div>
            <div class="flex-no-grow px-4 my-4">
              <svg
                class="text-gray-400 w-4 h-4"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "hello",
  data() {
    return {
      items: [
        {
          icon: require("@/assets/images/home/关于madmix.png"),
          title: "公司",
          link: "/company",
        },
        {
          icon: require("@/assets/images/home/产品图标.png"),
          title: "产品",
          link: "/products",
        },
        {
          icon: require("@/assets/images/home/资源服务中心图标.png"),
          title: "行业应用",
          link: "/industry-application",
        },
        {
          icon: require("@/assets/images/home/资源服务中心图标.png"),
          title: "资源/服务中心",
          link: "/resource",
        },
      ],
    };
  },
};
</script>
<style scoped></style>
